export const fr = {
  save: "Enregistrer",
  update: "Actualiser",
  accept: "Accepter",
  cancel: "Annuler",
  close: "Fermer",
  add: "Ajouter",
  check: "Vérifier",
  certificate: "Certificat",
  certificates: "Certificats",
  certification: "Certification",
  certifications: "Certifications",
  "valid-certificate": "Certificat valable",
  date: "Date",
  "valid-thru": "Valable jusqu'au",
  dashboard: "Page d'accueil",
  error: "Page d'erreur",
  forms: "Formulaires",
  notifications: "Notifications",
  "my-profile": "Mon profil",
  "my-documents": "Mes documents",
  "no-documents-available": "Aucun document disponible",
  "training-materials": "Supports de formation",
  "open-in-webviewer": "Ouvrir dans la visionneuse",
  expired: "Expiré",
  "expired-training-materials": "Supports de formation expirés",
  "register-headline": "Inscription",
  register: "S'inscrire",
  search: "Recherche",
  print: "Imprimer",
  "printed-via": "Imprimé via www.evalcard.com",
  settings: {
    label: "Paramètres",
    publicProfile: {
      showEmailInPublic: "Afficher l'e-mail",
      showPhoneInPublic: "Afficher le numéro de téléphone",
      showAddressInPublic: "Afficher l'adresse",
    },
  },
  tables: "Tableaux",
  tabs: "Onglets",
  myeval: "EvalCard",
  "eval-id": "Eval-ID",
  id: "ID",
  timeline: "Chronologie",
  typography: "Typographie",
  admin: "Administrateur",
  user: "Utilisateur",
  templateAuthor: "Créateur de modèles global",
  users: "Utilisateur",
  "user-profile": "Profil utilisateur",
  "company-name": "Nom de l'entreprise",
  "company-logo": "Logo de l'entreprise",
  "company-profile": "Profil de l'entreprise",
  "company-profile-admin": "Profil de l'entreprise",
  "company-invitation": "Invitation de l'entreprise",
  "invitation-sent": "Invitation envoyée",
  "new-password": "Nouveau mot de passe",
  "generate-new-password": "Générer un nouveau mot de passe",
  "current-password": "Mot de passe actuel",
  "repeat-password": "Répéter le mot de passe",
  "password-successfully-changed": "Votre mot de passe a été modifié avec succès",
  "password-reset": "Réinitialiser le mot de passe",
  "edit-user-profile": "Modifier le profil utilisateur",
  "edit-user-profile-admin": "Modifier le profil utilisateur",
  system: "Système",
  widgets: "Widgets",
  wizard: "Assistant",
  logout: "Se déconnecter",
  login: "Se connecter",
  companies: "Entreprises",
  "my-company": "Mon entreprise",
  "leave-company": "Quitter l'entreprise",
  "delete-company": "Supprimer l'entreprise",
  company: "Entreprise",
  uid: "N° de TVA/numéro fiscal",
  employees: "Employés",
  employee: "Collaborateur/trice",
  companyadmin: "Admin",
  evalclient: "Responsable EVAL",
  coworker: "Collaborateurs",
  "coworker-profile": "Profil du collaborateur",
  "search-user": "Rechercher un utilisateur",
  "search-user-placeholder": "Nom, e-mail, EVAL-ID",
  trainer: "Formateur",
  "training-level": "Niveau de formation",
  gtp: "GTP",
  authorityAdmin: "Admin",
  trainerRO: "Formateur (lecture seule)",
  authorityAdminRO: "Admin (lecture seule)",
  protocols: "Rapports de contrôle",
  report: "Rapport de contrôle",
  "new-report": "Nouveau rapport de contrôle",
  "all-reports": "Tous les rapports de contrôle",
  "all-assets": "Tous les objets",
  "report-from": "Rapport de contrôle du",
  "report-details": "Détails du rapport de contrôle",
  data: "Données",
  info: "Infos",
  attachment: "Pièce jointe",
  contact: "Contact",
  continue: "Continuer",
  start: "Démarrer",
  summary: "Résumé",
  vin: "VIN",
  "licence-plate": "Plaque d'immatriculation",
  owner: "Propriétaire",
  vehicles: "Véhicules",
  vehicle: "Véhicule",
  "vehicle-details": "Détails du véhicule",
  companyVehicle: "Véhicule d'entreprise",
  valid: "Conforme",
  invalid: "Non conforme",
  tester: "Contrôleur",
  "vehicles-admin": "Véhicules",
  "create-company-vehicle": "Créer un véhicule",
  "select-vehicle": "Sélection du véhicule",
  "my-vehicles": "Mes véhicules",
  "my-vehicle": "Mon véhicule",
  asset: "Objet",
  assets: "Objets",
  "serial-number": "Numéro de série",
  "asset-type": "Type d'objet",
  "asset-types": "Types d'objet",
  "calibration-valid-thru": "Étalonnage valable jusqu'au",
  "requires-calibration": "Doit être étalonné régulièrement",
  "calibration-warning-days": "Délai d'alerte (jours)",
  "gtp-classes": "Classes GTP",
  code: "Code",
  subtype: "Sous-type",
  icon: "Icône",
  qualification: "Qualification (HTML)",
  gtpIcon: {
    car: "Voiture",
    forklift: "Chariot élévateur",
    gauge: "Tachymètre",
    "train-front": "Train",
    ship: "Navire",
    plane: "Avion",
    settings: "Engrenage",
    wrench: "Clé plate",
  },
  photos: "Photos",
  "new-vehicle": "Nouveau véhicule",
  manufacturer: "Constructeur",
  "no-manufacturer": "(Aucun constructeur)",
  "no-vehicle": "(Aucun véhicule)",
  "vehicle-manufacturer": "Constructeur du véhicule",
  "create-vehicle": "Créer un véhicule",
  "create-vehicle-manufacturer": "Créer un constructeur de véhicule",
  "construction-year": "Année de construction",
  "change-password": "Modifier le mot de passe",
  roles: "Autorisations",
  actions: "Actions",
  action: "Action",
  profile: "Profil",
  email: "E-mail",
  basic: "Base",
  special: "Spécial",
  breakdown: "Répartition",
  "click-for-details": "Cliquer pour les détails",
  rights: "Droits",
  details: "Détails",
  information: "Informations",
  "details-and-information": "Détails et informations",
  name: "Nom",
  namename: "Désignation",
  firstname: "Prénom",
  lastname: "Nom de famille",
  fullname: "Nom complet",
  password: "Mot de passe",
  street: "Rue",
  number: "Numéro",
  city: "Ville",
  country: "Pays",
  "forgot-password": "Mot de passe oublié ?",
  "recover-password": "Réinitialiser le mot de passe",
  back: "Retour",
  "back-to-login": "Retour à la connexion",
  "go-to-login": "Vers la connexion",
  "choose-picture": "Sélectionner une image",
  "choose-logo": "Sélectionner un logo",
  "image-format-not-supported": "Ce format d'image n'est pas pris en charge. Veuillez choisir une image JPG ou PNG.",
  "send-invitation": "Envoyer l'invitation",
  zipcode: "Code postal",
  previous: "Retour",
  abort: "Annuler",
  "i-understand": "Compris",
  no: "Non",
  yes: "Oui",
  inputs: "Saisies",
  "user-activated": "Activé",
  "user-not-activated": "L'utilisateur n'est pas encore activé",
  "user-did-not-receive-activation-email": "L'utilisateur n'a pas encore reçu d'e-mail d'activation",
  "allow-coworkers-to-show-on-profile": "Afficher sur le profil utilisateur des collaborateurs :",
  "resend-activation-email": "Demander un lien d'activation",
  "coworker-education-status": "Statut de formation des collaborateurs",
  card: "Carte de visite",
  "certification-authority": "Organisme de certification",
  "certification-authority-admin": "Organisme de certification",
  "certification-authorities": "Organismes de certification",
  "delete-certification-authority": "Supprimer l'organisme de certification",
  "certificate-templates": "Modèles de certificat",
  "certificate-template": "Modèle de certificat",
  "creating-certificates": "Les certificats sont en cours de création...",
  "issue-certificate": "Délivrer le certificat",
  "issue-date": "Date de délivrance",
  "due-date": "Date d'expiration",
  "issued-on": "Délivré le",
  "issued-by": "Délivré par",
  author: "Émetteur",
  "certificate-name": "Nom du certificat",
  "certificate-number": "Numéro du certificat",
  "born-on": "né le",
  mileage: "Kilométrage",
  public: "Public",
  "back-to-the-app": "Retour à l'application",
  "can-create-reports": "Rapports de contrôle possibles",
  "temporary-certification": "Certification temporaire",
  "temporary-days-valid": "Valable pour (jours)",
  "valid-for": "Valable pour (ans)",
  "pdf-template": "Modèle PDF",
  "pdf-certificate": "Certificat PDF personnalisé",
  "show-pdf-certificate": "Certificat en PDF",
  standards: "Normes (HTML)",
  "text-block": "Texte après les normes (HTML)",
  "text-block-hint": "Espace réservé : {placeholders} — qualifikationen insère les textes des classes GTP attribuées",
  "digital-signature": "Signature numérique",
  eval0: "HV-0",
  eval1: "HV-1",
  eval2: "HV-2",
  eval3: "HV-3",
  eval4: "HV-4",
  evalc: "HV-C",
  evalbex: "HV-BEX",
  evall: "HV-L",
  evalf: "HV-F",
  evalpro: "HV-Pro",
  evals: "HV-S",
  evalt: "HV-T",
  sonstige: "Divers",
  others: "Autre",
  levelGroupBase: "Niveaux de base",
  levelGroupSpecial: "Spécial – formation préalable requise",
  levelGroupSpecialTraining: "Formations spéciales sans prérequis",
  level: "Niveau",
  type: "Type",
  "training-data": "Supports de formation",
  "training-info": "Informations sur la formation",
  "generated-password": "Mot de passe généré",
  "invitation-email": "E-mail d'invitation",
  document: "Document",
  documents: "Documents",
  active: "actif",
  inactive: "inactif",
  all: "TOUS",
  "all-sort": "Tous/Trier",
  "created-on": "Créé le",
  result: "Résultat",
  results: "Résultats",
  "try-again": "Réessayer",
  status: "Statut",
  published: "Publié",
  draft: "Brouillon",
  sn: "SN",
  "something-went-wrong": "Une erreur s'est produite",
  "checking-prerequisites": "Vérification des prérequis...",
  "prerequisite-warning-title": "Prérequis manquants",
  "missing-prerequisites": "Nécessite au moins :",
  "info-signs": "Panneaux d'avertissement",
  danger: "Attention",
  "hazardous-voltage": "Tension dangereuse",
  "no-access-1": "Aux personnes non autorisées",
  "no-access-2": "Accès interdit",
  "access-only-by": "Accès uniquement par",
  "company-logo-is-missing": "Logo de l'entreprise manquant",
  download: "Télécharger",
  "access-denied": "Accès interdit",
  "dont-switch-on": "Ne pas mettre sous tension",
  "hv-system": "Système HT",
  disconnected: "Consigné",
  "disconnected-by": "Consigné par",
  "works-in-progress": "Travaux en cours",
  forum: "Forum EV",
  topic: "Sujet",
  topics: "Sujets",
  title: "Titre",
  created: "Créé",
  "created-by": "Créé par",
  "is-global": "Modèle global",
  "templateauthor-requires-report-permission": "Seuls les utilisateurs autorisés à créer des rapports peuvent devenir créateurs de modèles globaux.",
  from: "de",
  answers: "Réponses",
  "post-answer": "Publier la réponse",
  "edit-answer": "Modifier la réponse",
  "new-topic": "Nouveau sujet",
  "edit-topic": "Modifier le sujet",
  "create-new-topic": "Créer un nouveau sujet",
  "last-answer": "Dernière réponse",
  "view-all": "Voir tout",
  attachments: "Pièces jointes",
  "link-url": "Lien (URL)",
  "newest-topics": "Sujets les plus récents",
  "privacy-policy": "Protection des données",
  "new-files": "Nouveaux fichiers",
  "existing-files": "Fichiers existants",
  courses: "Cours",
  location: "Site",
  loading: "Charger",
  "view-details": "Afficher les détails",
  "no-courses-found": "Aucun cours trouvé",
  "no-courses-assigned": "Aucun cours disponible",
  dialog: {
    "are-you-sure": "Êtes-vous sûr ?",
    "an-unexpected-error-occured": "Une erreur inattendue s'est produite. Réessayez plus tard",
    "do-you-really-want-the-user-to": "Voulez-vous vraiment l'utilisateur",
    "do-you-really-want-the-invitation-to": "Voulez-vous vraiment l'invitation",
    delete: "supprimer",
    "delete-user": "Supprimer l'utilisateur",
    "delete-topic": "Supprimer le sujet",
    "delete-topic-answer": "Supprimer la réponse",
    "remove-user": "Retirer l'utilisateur",
    "remove-trainer": "Retirer le contrôleur",
    "remove-from-company": "retirer de l'entreprise ?",
    "remove-from-certification-authority": "retirer de l'organisme de certification ?",
    "create-user": "Créer un utilisateur",
    "the-most-important-information": "Les informations les plus importantes",
    "create-company": "Créer une entreprise",
    "the-most-important-information-about-the-company": "Les informations les plus importantes de l'entreprise",
    "create-company-vehicle": "Créer un véhicule d'entreprise",
    "the-most-important-information-about-the-vehicle": "Les informations les plus importantes du véhicule",
    "the-most-important-information-about-the-asset": "Les informations les plus importantes de l'objet",
    "create-report": "Créer un rapport de contrôle",
    "where-is-the-company-located": "Où se trouve l'entreprise ?",
    "where-is-the-certification-authority-located": "Où se trouve l'organisme de certification ?",
    "whats-the-role-of-the-person": "Quelle est la fonction de la personne ?",
    "where-does-the-person-live": "Où habite la personne ?",
    "further-details": "Autres détails",
    "register-successfull": "L'inscription a réussi ! Vous recevrez sous peu un e-mail avec votre mot de passe.",
    "great-you-will-receive-an-email": "Vous recevrez sous peu un e-mail vous permettant de réinitialiser votre mot de passe",
    "this-should-not-take-longer-than": "Cela ne devrait pas prendre plus de 5 minutes. Si c'est le cas, vérifiez également votre dossier spam.",
    "i-agree": "J'accepte les",
    "terms-and-conditions": "conditions générales de vente",
    "hereby-i-agree": "J'accepte par la présente que EvalCert GmbH puisse utiliser mes données personnelles aux fins de la délivrance d'une carte EVAL et de l'inscription des utilisateurs sur my.evalcard.com.",
    "further-i-agree-to": "J'accepte en outre que EvalCert GmbH puisse m'informer par newsletter par e-mail des nouveautés dans le domaine de la haute tension (nouvelles formations, nouveautés produits ou événements), jusqu'à révocation.",
    "allowed-to-be-used": " (.de ou .com) peut être utilisé.",
    "refusal-is-allways": "Une révocation est possible à tout moment par e-mail à",
    possible: "possible.",
    "the-e-val-card-is-the": "La carte EVAL est le justificatif de qualification au format carte de crédit. L'abréviation EVAL signifie Electric Vehicle Access License",
    "complete-user-data": "Compléter les données utilisateur",
    "complete-user-data-info": "Afin de pouvoir vous accompagner au mieux et mettre toutes les fonctions à votre disposition, nous avons besoin d'un profil utilisateur entièrement complété",
    "your-password-reset-is-being-processed": "Votre mot de passe est en cours de réinitialisation. Si cela prend plus de quelques minutes, réessayez.",
    "your-password-has-been-sent": "Votre mot de passe a été réinitialisé avec succès. Vous devriez recevoir dans quelques minutes un e-mail avec votre nouveau mot de passe.",
    "if-it-did-not-work": "Vérifiez également votre dossier spam. Si vous n'avez pas reçu votre nouveau mot de passe dans les 5 à 10 minutes, réessayez.",
    "user-not-authorized": "E-mail et/ou mot de passe incorrect",
    "user-not-activated": "Cet utilisateur n'est pas encore activé. Utilisez le lien dans l'e-mail d'activation",
    "user-or-password-wrong": "L'e-mail ou le mot de passe est incorrect",
    "users-selected": "Utilisateur sélectionné",
    "user-profile-update-successfull": "Le profil utilisateur a été enregistré avec succès",
    "user-profile-update-failed": "Le profil utilisateur n'a pas pu être enregistré. Veuillez réessayer plus tard.",
    "do-you-really-want-to-leave-the-company": "Voulez-vous vraiment quitter l'entreprise ?",
    "in-order-to-accept-a-company-invitation": "Pour pouvoir accepter une invitation d'entreprise, vous devez déjà être inscrit et connecté",
    "do-you-really-want-to-join-the-company": "Êtes-vous sûr de vouloir rejoindre l'entreprise ?",
    "if-you-are-already-in-a-company-you-will-be-removed": "Si vous êtes déjà dans une entreprise, vous en serez retiré",
    "you-are-not-a-member-of-a-company": "Vous n'êtes actuellement affecté à aucune entreprise. Dès que vous serez membre d'une entreprise, vous pourrez utiliser cette page.",
    "you-are-not-a-member-of-a-certification-authority": "Vous n'êtes actuellement affecté à aucun organisme de certification",
    "do-you-really-want-the-company-to": "Voulez-vous vraiment l'entreprise",
    "company-created-successfully": "L'entreprise a été créée avec succès",
    "company-already-exists": "Une entreprise avec ce nom ou cet e-mail existe déjà. L'entreprise n'a donc pas pu être créée",
    "vehicle-save-successfully": "Le véhicule a été enregistré avec succès",
    "asset-save-successfully": "L'objet a été enregistré avec succès",
    "gtp-class-save-successfully": "La classe GTP a été enregistrée avec succès",
    "gtp-class-already-exists": "Une classe GTP avec ce code existe déjà",
    "do-you-really-want-the-gtp-class-to": "Voulez-vous vraiment la classe GTP",
    "asset-type-save-successfully": "Le type d'objet a été enregistré avec succès",
    "do-you-really-want-the-asset-type-to": "Voulez-vous vraiment le type d'objet",
    "vehicle-already-exists": "Un véhicule avec ce VIN et ce propriétaire existe déjà",
    "vehicle-accepted": "Le véhicule a été intégré au système",
    "vehicle-manufacturer-accepted": "Le constructeur du véhicule a été intégré au système",
    "report-save-successfully": "Le rapport de contrôle a été enregistré avec succès",
    "report-already-exists": "Un rapport de contrôle avec ce nom ou ce type existe déjà dans cette entreprise.",
    "create-company-failed": "L'entreprise n'a pas pu être créée. Veuillez réessayer plus tard.",
    "save-user-success": "L'utilisateur a été enregistré avec succès",
    "user-already-exists": "Un utilisateur avec cet e-mail ou ce nom existe déjà.",
    "save-company-success": "L'entreprise a été enregistrée avec succès",
    "save-company-failed": "L'entreprise n'a pas pu être enregistrée. Veuillez réessayer plus tard.",
    "save-changes-success": "Les modifications ont été enregistrées avec succès",
    "do-you-really-want-the-vehicle-to": "Voulez-vous vraiment le véhicule",
    "do-you-really-want-the-asset-to": "Voulez-vous vraiment l'objet",
    "do-you-really-want-the-report-to": "Voulez-vous vraiment le rapport de contrôle",
    "do-you-really-want-the-certificate-to": "Voulez-vous vraiment le certificat",
    "do-you-really-want-the-vehicle-manufacturer-to": "Voulez-vous vraiment le constructeur du véhicule",
    "save-vehicle-manufacturer-success": "Le constructeur du véhicule a été enregistré avec succès",
    "save-vehicle-manufacturer-error": "Le constructeur du véhicule n'a pas pu être enregistré",
    "save-vehicle-success": "Le véhicule a été enregistré avec succès",
    "save-vehicle-error": "Le véhicule n'a pas pu être enregistré",
    "who-works-in-the-company": "Qui travaille dans l'entreprise ?",
    "who-works-in-the-certification-authority": "Qui travaille dans l'organisme de certification ?",
    "your-company-has-been-created-check-your-emails": "Votre entreprise a été créée ! Vous devriez recevoir sous peu un e-mail vous permettant d'activer votre entreprise ! Vérifiez le cas échéant votre dossier spam.",
    "if-you-havent-received-an-email-yet": "Si vous n'avez pas reçu d'e-mail dans les 5 minutes, vous pouvez le demander à nouveau ici.",
    "if-this-did-not-work": "Si cela n'a toujours pas fonctionné, vous pouvez aussi quitter votre entreprise et en créer une nouvelle.",
    "is-already-in-a-company": "est déjà dans une entreprise",
    "invite-user-already-exists-in-company": "L'utilisateur avec cet e-mail est déjà dans l'entreprise",
    "invite-user-already-exists-in-other-company": "L'utilisateur avec cet e-mail est déjà dans une autre entreprise",
    "create-certification-authority": "Créer un organisme de certification",
    "certification-authority-save-successfully": "L'organisme de certification a été enregistré avec succès",
    "certification-authority-already-exists": "Un organisme de certification avec cet e-mail ou ce nom existe déjà.",
    "certificate-already-exists": "Une certification avec ce nom existe déjà pour cet utilisateur.",
    "certificate-save-successfully": "La certification a été enregistrée avec succès",
    "do-you-really-want-to-delete": "Voulez-vous vraiment supprimer",
    "delete-report-template": "Supprimer le modèle",
    "create-certificate": "Créer un certificat",
    "create-certificate-template": "Créer un modèle de certificat",
    "who-gets-the-certificate": "À qui le certificat doit-il être délivré",
    "user-with-this-eval-id-was-not-found": "Aucun utilisateur avec cet Eval-ID n'a été trouvé",
    "you-can-only-add-reports-if-you-have-company-vehicles": "Vous ne pouvez créer un rapport que si vous possédez des véhicules d'entreprise",
    "you-can-only-input-eu-numbers": "Seuls les nombres au format UE sont possibles",
    "you-dont-have-the-rights": "Aucune autorisation pour cette section",
    "certificate-template-save-success": "Le modèle de certificat a été enregistré avec succès",
    "certificate-template-sort-save-success": "L'ordre des modèles de certificat a été enregistré avec succès",
    "your-certification-authority-does-not-have-templates": "Veuillez d'abord créer un modèle de certificat pour pouvoir délivrer des certificats",
    "this-company-is-not-yet-activated": "Cette entreprise n'a pas encore été activée. Le lien d'activation a été envoyé à l'adresse e-mail de l'entreprise",
    "welcome-to-the-dashboard": "Bienvenue sur la page d'accueil ! Vous n'êtes actuellement affecté à aucune entreprise. Dès que vous serez membre d'une entreprise, vous pourrez voir ici un aperçu de vos protocoles",
    "valid-certificates": "Certificats valables",
    "certificates-last-30-days": "Certificats – 30 derniers jours",
    "certificates-on": "Certificats le",
    "reports-last-30-days": "Rapports – 30 derniers jours",
    "no-data-available": "Aucune donnée disponible pour le moment",
    "this-manufacturer-does-not-exist": "Ce constructeur n'est pas encore dans le système. Il sera créé automatiquement pour vous.",
    "this-vehicle-does-not-exist": "Ce véhicule n'est pas encore dans le système. Il sera créé automatiquement pour vous.",
    "required-to-complete-registration": "Pour pouvoir finaliser l'inscription, un consentement est nécessaire",
    "email-is-already-used": "Cet e-mail est déjà utilisé",
    "enter-valid-birthday-date": "Veuillez saisir une date de naissance valide",
    "enter-valid-eu-number-format": "Veuillez utiliser uniquement des nombres au format UE",
    "only-use-numbers-with-or": "Veuillez utiliser uniquement des chiffres et '-' ou '/'",
    "this-user-is-already-in-this-certification-authority": "Cet utilisateur est déjà dans cet organisme de certification",
    "this-user-is-already-selected": "Cet utilisateur est déjà sélectionné",
    "this-user-is-already-in-a-company": "Cet utilisateur est déjà dans une entreprise",
    "the-document-could-not-be-loaded": "Le document n'a pas pu être chargé",
    continue: "Continuer",
    finish: "Terminé",
    "cannot-add-users": "Les utilisateurs suivants présentaient des conflits :",
    "add-course": "Ajouter un cours",
    "course-created-successfully": "Cours créé avec succès.",
    "course-updated-successfully": "Cours mis à jour avec succès.",
    "mark-course-as-free": "Marquer le cours comme gratuit",
    "scan-qr-code": "Scanner le code QR",
    "scan-to-join-course": "Scannez le code QR pour rejoindre le cours",
    "remove-participant": "Retirer le participant",
    "remove-participant-description": "Retirer ce participant du cours ?",
    "user-is-already-participant": "Cet utilisateur est déjà participant au cours",
    "user-already-selected": "L'utilisateur a déjà été sélectionné",
    "delete-course": "Supprimer le cours",
    "delete-course-description": "Ce cours sera supprimé. Tous les participants seront retirés. Continuer ?",
    "course-removed": "Le cours a été retiré",
    "remove-efk-success": "Statut ESP retiré avec succès",
    "create-checklist": "Créer une liste de contrôle",
    "make-efk-success": "Statut ESP attribué avec succès, l'utilisateur a été informé",
    "resend-efk-success": "L'invitation ESP a été envoyée à nouveau",
    "participants-added-successfully": "Participant ajouté avec succès",
    "delete-document": "Supprimer le document",
    "delete-document-description": "Voulez-vous vraiment supprimer ce document ?",
    "delete-certificate-template": "Supprimer le modèle de certificat",
    "do-you-really-want-the-certificate-template-to": "Voulez-vous vraiment le modèle de certificat",
    "do-you-really-want-the-certification-authority-to": "Voulez-vous vraiment l'organisme de certification",
    "delete-task": "Supprimer la tâche",
    "do-you-really-want-to-delete-the-task": "Voulez-vous vraiment supprimer la tâche « {name} » ?",
    "delete-section": "Supprimer la section",
    "do-you-really-want-to-delete-the-section": "Voulez-vous vraiment supprimer la section « {name} » ?",
    "course-content-saved-successfully": "Contenus du cours enregistrés avec succès",
    "remove-certification-authority": "Retirer l'organisme de certification",
    "do-you-really-want-to-remove-certification-authority": "Voulez-vous vraiment retirer l'organisme de certification « {name} » ?",
    "remove-course-content": "Retirer le contenu du cours",
    "do-you-really-want-to-remove-course-content": "Voulez-vous vraiment retirer le contenu du cours « {name} » ?",
    "successfully-removed-course-content": "Contenu du cours retiré avec succès",
    "language-already-exists-in-course": "La langue sélectionnée existe déjà dans ce cours",
    "do-you-really-want-to-remove-course": "Voulez-vous vraiment retirer le cours « {name} » ?",
    "successfully-removed-course": "Cours retiré avec succès",
    "publish-course-warning": "Êtes-vous sûr de vouloir publier « {name} » ? Après la publication, le cours ne peut plus être modifié tant qu'il n'est pas dépublié.",
    "unpublish-course-confirmation": "Êtes-vous sûr de vouloir dépublier « {name} » ? Cela permet à nouveau des modifications.",
    "course-published-successfully": "Cours publié avec succès",
    "course-unpublished-successfully": "Publication du cours annulée avec succès",
    "successfully-enrolled-course": "Inscription au cours réussie",
    "remove-enrollment": "Retirer l'inscription",
    "do-you-really-want-to-remove-enrollment": "Voulez-vous vraiment retirer cette inscription ?",
    "successfully-removed-enrollment": "Inscription retirée avec succès",
  },
  tooltip: {
    "csv-export": "Export CSV",
    "add-user": "Ajouter un utilisateur",
    "invite-user": "Inviter un utilisateur",
    "delete-user": "Supprimer l'utilisateur",
    "remove-user": "Retirer l'utilisateur",
    "edit-user": "Modifier l'utilisateur",
    "view-user": "Voir l'utilisateur",
    "send-invitation-again": "Renvoyer l'invitation",
    "send-activation-again": "Renvoyer le lien d'activation",
    "admin-cant-leave-company": "En tant que responsable EVAL, vous ne pouvez pas quitter l'entreprise",
    "leave-company": "Quitter l'entreprise",
    "add-company": "Ajouter une entreprise",
    "edit-company": "Modifier l'entreprise",
    "delete-company": "Supprimer l'entreprise",
    "add-selected-users-to-company": "Ajouter les utilisateurs sélectionnés à une entreprise",
    "add-selected-users-to-course": "Ajouter les utilisateurs sélectionnés à un cours",
    "add-vehicle": "Ajouter un véhicule",
    "show-vehicle": "Détails du véhicule",
    "edit-vehicle": "Modifier le véhicule",
    "view-vehicle": "Voir le véhicule",
    "accept-vehicle": "Intégrer le véhicule au système",
    "accept-vehicle-manufacturer": "Intégrer le constructeur du véhicule au système",
    "delete-vehicle": "Supprimer le véhicule",
    "add-asset": "Ajouter un objet",
    "add-gtp-class": "Ajouter une classe GTP",
    "edit-gtp-class": "Modifier la classe GTP",
    "delete-gtp-class": "Supprimer la classe GTP",
    "add-asset-type": "Ajouter un type d'objet",
    "edit-asset-type": "Modifier le type d'objet",
    "delete-asset-type": "Supprimer le type d'objet",
    "show-asset": "Détails de l'objet",
    "edit-asset": "Modifier l'objet",
    "delete-asset": "Supprimer l'objet",
    "add-vehicle-manufacturer": "Ajouter un constructeur de véhicule",
    "edit-vehicle-manufacturer": "Modifier le constructeur de véhicule",
    "delete-vehicle-manufacturer": "Supprimer le constructeur de véhicule",
    "vehicle-details-missing": "Détails du véhicule manquants",
    "remove-invitation": "Supprimer l'invitation",
    "send-missing-activations": "Envoyer les e-mails d'activation manquants",
    "show-password": "Afficher le mot de passe",
    "hide-password": "Masquer le mot de passe",
    "create-report": "Créer un rapport de contrôle",
    "select-for-report": "Sélectionner pour le rapport de contrôle",
    "add-question": "Ajouter un champ",
    "remove-question": "Retirer le champ",
    "create-certificates": "Créer des certificats",
    "view-certificate": "Voir le certificat",
    "delete-certificate": "Supprimer le certificat",
    "view-report": "Voir le rapport de contrôle",
    "delete-report": "Supprimer le rapport de contrôle",
    "no-pdf-found": "Aucun document PDF n'a été trouvé",
    "add-report": "Ajouter un rapport de contrôle",
    "add-certificate": "Créer un certificat",
    "no-certificate-to-create-report": "Vous n'avez pas de certificat correspondant",
    "add-certification-authority": "Créer un organisme de certification",
    "edit-certification-authority": "Modifier l'organisme de certification",
    "delete-certification-authority": "Supprimer l'organisme de certification",
    "add-certificate-template": "Créer un modèle de certificat",
    "edit-certificate-template": "Modifier le modèle de certificat",
    "delete-certificate-template": "Supprimer le modèle de certificat",
    "add-report-template": "Ajouter un modèle de rapport",
    "edit-report-template": "Modifier le modèle de rapport",
    "delete-report-template": "Supprimer le modèle de rapport",
    "view-certificate-training-data": "Voir les supports de formation",
    "save-sorting": "Enregistrer l'ordre",
    "mark-user": "Sélectionner l'utilisateur",
    "open-topic": "Voir le sujet",
    "edit-topic": "Modifier le sujet",
    "delete-topic": "Supprimer le sujet",
    "edit-topic-answer": "Modifier la réponse",
    "delete-topic-answer": "Supprimer la réponse",
    "select-all-users": "Sélectionner tous les utilisateurs",
    "add-course": "Ajouter un cours",
    "show-qr": "Afficher le code QR",
    "edit-course": "Modifier le cours",
    "publish-course": "Publier le cours",
    "unpublish-course": "Dépublier le cours",
    "remove-course": "Supprimer le cours",
    "view-course": "Voir le cours",
    "remove-efk": "Retirer le statut ESP",
    "see-more": "Afficher plus",
  },
  phone: "Numéro de téléphone",
  address: "Adresse",
  birthday: "Date de naissance",
  "profile-picture": "Photo de profil",
  userprofile: {
    "edit-profile": "Modifier le profil",
    "public-profile": "Profil public",
    "following-information": "Les informations suivantes sont affichées dans votre profil public",
    "notification-settings": "Si votre entreprise n'envoie pas de notifications, ce paramètre n'a aucun effet",
  },
  "training-director": "Responsable de formation",
  "participated-the-training": "a participé à la formation ",
  "result-protocol": "Procès-verbal des résultats",
  measurements: "Valeurs mesurées",
  freischaltung: "Consignation",
  isolationswiderstand: "Résistance d'isolement",
  potentialausgleich: "Liaison équipotentielle",
  r: {
    "measuring-instrument-functionality": "Fonction de l'appareil de mesure",
    "positive-test-done": "Test positif effectué",
    "voltage-between-hv-plus-and-chassis": "Tension entre HV-plus et châssis",
    "voltage-between-hv-plus-and-hv-minus": "Tension entre HV-plus et HV-moins",
    "voltage-between-hv-minus-and-chassis": "Tension entre HV-moins et châssis",
    "the-tester-accepts-the-security-instructions": "Le contrôleur confirme le respect des consignes de sécurité du constructeur",
    "measuring-instrument-tested-at-reference-source": "La fonction de l'appareil de mesure a-t-elle été vérifiée sur une source de référence ?",
    "measuring-instrument-tested": "La fonction de l'appareil de mesure a-t-elle été vérifiée ?",
    "absence-of-voltage": "Absence de tension",
    "absence-of-voltage-confirmed": "Absence de tension constatée",
    voltage: "Tension (V)",
    "used-voltage": "Tension utilisée",
    "used-test-voltage": "Tension d'essai appliquée",
    "isolation-standard": "Valeur de consigne de la résistance d'isolement",
    "resistance-per-volt": "Résistance par volt",
    "hv-system-voltage": "Tension de service HT / tension système HT",
    "isolation-resistance-between-hv-plus-and-chassis": "Résistance d'isolement entre HV-plus et châssis",
    "isolation-resistance-between-hv-minus-and-chassis": "Résistance d'isolement entre HV-moins et châssis",
    "further-measurements-if-needed": "Autre mesure si souhaité",
    "test-current": "Courant d'essai (A)",
    "test-current-q": "Courant d'essai ...",
    "measuring-point": "Point de mesure",
    "measuring-point-chassis-vs": "Point de mesure châssis contre ...",
    "converter-housing": "Boîtier de l'onduleur",
    "further-voltage-measurements-if-needed": "Autre mesure de tension si souhaité",
    "measurements-ok-if-smaller-than-1-v": "Résultat de mesure positif si la tension mesurée est inférieure à 1 V",
    "visual-inspection": "Contrôle visuel",
    "cable-visual-inspection": "Le câble a-t-il été contrôlé pour détecter des dommages visibles ?",
    "connector-visual-inspection": "Le connecteur a-t-il été contrôlé pour détecter des dommages visibles ?",
    "isolation-test": "Contrôle d'isolement",
    "cable-isolation-test": "La résistance d'isolement du câble a-t-elle été contrôlée ?",
    "function-test": "Test de fonctionnement",
    "cable-function-test": "Le processus de charge a-t-il été testé avec succès ?",
    "charging-cable-inspection-notes": "Autres contrôles si nécessaire",
  },
  "new-report-no-id": "Nouveau rapport de contrôle",
  "required-field": "Ce champ est obligatoire.",
  "fill-out-all-required-fields": "Veuillez remplir tous les champs obligatoires !",
  "valid-email-only": "Veuillez saisir un e-mail valide.",
  "max-characters": "Max. {count} caractères",
  "certificate-notification": "Notifications de certificat",
  "certificate-notification-company": "Cela permet de désactiver les notifications pour tous les collaborateurs.",
  "calibration-notification": "Notifications d'étalonnage",
  "calibration-notification-company": "Rappel avant l'expiration de l'étalonnage d'un objet.",
  "haynes-pro-vehicle-details": "Détails du véhicule HaynesPro",
  "haynes-pro-no-details": "Aucun détail de véhicule n'est disponible pour le véhicule sélectionné.",
  "haynes-pro-hv-disconnect": "Système haute tension : mettre hors tension",
  "vehicle-details-admin": "Détails du véhicule",
  "haynes-pro-details": "Détails HaynesPro",
  "haynes-pro-details-admin": "Détails HaynesPro",
  "haynes-pro-details-not-found": "Malheureusement, rien n'a été trouvé pour ce véhicule.",
  "haynes-pro-load-error": "Les instructions n'ont pas pu être chargées.",
  retry: "Réessayer",
  "haynes-pro-details-more-than-one-story": "Plus d'une instruction a été trouvée :",
  participants: "Participants",
  "join-course": "Rejoindre le cours",
  "join-course-description": "Vraiment rejoindre le cours ? Le formateur du cours pourra alors vous gérer en tant que participant.",
  "course-id-required": "L'ID du cours est obligatoire pour rejoindre un cours !",
  "course-not-found": "Cours introuvable",
  "error-loading-course": "Erreur lors du chargement du cours",
  "successfully-joined-course": "Cours rejoint avec succès",
  "error-joining-course": "Erreur lors de l'adhésion, contactez votre formateur.",
  refresh: "Recharger",
  "edit-course": "Modifier le cours",
  "make-efk": "Nommer en tant qu'ESP",
  "make-efk-description": "Nommer cet utilisateur en tant qu'ESP ? Il doit le confirmer.",
  "resend-efk-invitation": "Renvoyer l'invitation ESP",
  "cancel-efk": "Annuler la nomination ESP",
  efk: "ESP",
  "efk-position": "Poste d'ESP (électricien qualifié)",
  "do-you-want-to-accept-efk-position": "Souhaitez-vous accepter le poste d'ESP (électricien qualifié) ?",
  "do-you-want-to-refuse-efk-position": "Souhaitez-vous refuser le poste d'ESP (électricien qualifié) ?",
  refuse: "Refuser",
  "in-order-to-handle-efk-position": "Pour pouvoir accepter le poste d'ESP (électricien qualifié), vous devez déjà être inscrit et connecté",
  "efk-position-accepted": "Le poste d'ESP (électricien qualifié) a été accepté",
  "efk-position-refused": "Le poste d'ESP (électricien qualifié) a été refusé",
  pending: "En attente",
  "remove-efk-description": "Souhaitez-vous retirer le poste d'ESP à cet utilisateur ?",
  "cancel-efk-description": "Voulez-vous vraiment annuler l'invitation ESP pour cet utilisateur ?",
  aborted: "Refusé",
  checklists: "Listes de contrôle",
  "all-checklists": "Toutes les listes de contrôle",
  manage: "Gérer",
  "global-templates": "Modèles globaux",
  "global-template-authors": "Créateurs de modèles globaux",
  "add-global-template-author": "Ajouter un créateur global",
  "remove-global-template-author-confirm": "Vraiment retirer en tant que créateur de modèles globaux ?",
  "report-templates": "Modèles de rapport",
  "report-template": "Modèle de rapport",
  "create-report-template": "Créer un modèle de rapport",
  "edit-report-template": "Modifier le modèle de rapport",
  "delete-report-template": "Supprimer le modèle de rapport",
  checklist: "Liste de contrôle",
  form: "Rapport de contrôle du véhicule",
  "basic-information": "Informations de base",
  "object-data": "Données de l'objet",
  "object-data-configuration": "Configuration des données de l'objet",
  "object-data-config-description": "Configurez des champs personnalisés pour la saisie des données",
  "requires-vehicle": "Lié au véhicule",
  "assigned-vehicles": "Véhicules attribués",
  "assigned-vehicles-hint": "Vide = s'applique à tous les véhicules",
  "assigned-vehicles-no-data": "Rechercher un véhicule …",
  "available-reports": "Rapports disponibles",
  "create-report-now": "Créer un rapport",
  "vehicle-added-to-fleet": "Le véhicule figure désormais dans vos véhicules d'entreprise",
  "requires-asset": "Lié à l'objet",
  "select-asset": "Sélectionner un objet",
  "field-name": "Nom du champ",
  "display-name": "Nom affiché",
  "add-field": "Ajouter un champ",
  "questions-description": "Configurez les questions pour ce modèle",
  "add-question": "Ajouter une question",
  "example-images": "Images d'exemple",
  "upload-example-images": "Télécharger des images d'exemple",
  "remove-image": "Retirer l'image",
  "images-uploaded-successfully": "Images téléchargées avec succès",
  "error-uploading-images": "Erreur lors du téléchargement des images",
  "enable-validation": "Activer la validation",
  "validation-configuration": "Configuration de la validation",
  "expected-value": "Valeur attendue",
  "at-least-one-language-required": "Au moins une langue est requise",
  "language-not-available": "Cette langue n'existe pas",
  "multilingual-fields-info": "Champs multilingues : saisissez uniquement les langues pour lesquelles vous avez des traductions. Au moins une langue est requise pour les noms et les questions.",
  operator: "Opérateur",
  "validation-value": "Valeur de validation",
  equal: "Égal",
  "less-than": "Inférieur à",
  "greater-than": "Supérieur à",
  "form-vehicle-info": "Ceci est un modèle de formulaire. Les formulaires sont utilisés lorsqu'un véhicule est requis pour le rapport.",
  "checklist-object-data-info": "Ceci est un modèle de liste de contrôle. Les listes de contrôle utilisent la configuration des données de l'objet au lieu des véhicules.",
  "protocols-title": "Rapports",
  "evalus-reports": "Modèles généraux",
  "company-reports": "Rapports de l'entreprise",
  "custom-templates": "Modèles personnalisés",
  description: "Description",
  questions: "Questions de contrôle",
  question: "Question",
  unit: "Unité",
  boolean: "Oui/Non",
  text: "Texte",
  "question-type-number": "Nombre",
  dropdown: "Sélection",
  options: "Options",
  option: "Option",
  "add-option": "Ajouter une option",
  "expected-option": "Option attendue",
  "dropdown-options-required": "Chaque question à choix nécessite au moins une option remplie",
  "no-questions-yet": "Pas encore de questions — ajoute la première",
  "no-fields-yet": "Pas encore de champs — ajoute le premier",
  "question-incomplete": "Cette question est encore incomplète",
  "is-active": "Actif",
  "add-checklist": "Ajouter une liste de contrôle",
  "select-checklist-template": "Sélectionnez un modèle de liste de contrôle",
  "no-checklist-templates-available": "Aucun modèle de liste de contrôle n'est disponible.",
  template: "Modèle",
  "checklist-object-data": "Données du rapport",
  "report-template-saved": "Le modèle de rapport a été enregistré avec succès",
  "new-checklist": "Nouvelle liste de contrôle",
  "view-checklist": "Afficher la liste de contrôle",
  "checklist-from": "Liste de contrôle du",
  "checklist-details": "Détails de la liste de contrôle",
  field: "Champ",
  "checklist-created-successfully": "La liste de contrôle a été créée avec succès",
  "error-creating-checklist": "Erreur lors de la création de la liste de contrôle. Veuillez réessayer plus tard.",
  "tested-with-object": "Avec l'objet",
  "required-asset-type": "Type d'objet requis",
  "required-asset-type-hint": "Type d'objet avec lequel ce contrôle de véhicule doit être effectué. Laisser vide si aucun objet n'est nécessaire.",
  "can-calibrate": "Peut étalonner des objets",
  "calibratable-asset-type": "Type d'objet étalonnable",
  "calibratable-asset-type-hint": "Seuls les objets de ce type peuvent être étalonnés avec cette liste de contrôle.",
  "calibration-validity-months": "Validité de l'étalonnage (mois)",
  "calibration-validity-months-hint": "Si cette liste de contrôle est complétée sans erreur, l'objet est à nouveau considéré comme étalonné pendant autant de mois.",
  "select-required-asset": "Objet utilisé",
  "asset-locked-calibration-expired": "Bloqué – étalonnage expiré depuis plus de {days} jours ({date})",
  "asset-calibration-expired-on": "Étalonnage expiré le {date}",
  "asset-restricted-hint": "Ce contrôle ne peut être effectué qu'avec un objet du type « {type} ».",
  "asset-none-of-required-type": "Votre entreprise n'a pas d'objet du type « {type} ». Créez d'abord un objet approprié pour pouvoir effectuer ce contrôle.",
  "asset-all-expired": "Pour tous les objets appropriés, l'étalonnage a expiré depuis plus de {days} jours, ils sont donc bloqués. Mettez à jour la date d'étalonnage sur l'objet pour continuer.",
  "asset-no-longer-allowed": "L'objet sélectionné n'est (plus) autorisé pour ce contrôle – il est possible que l'étalonnage ait expiré depuis trop longtemps entre-temps. Veuillez vérifier la sélection.",
  "add-users-to-course": "Ajouter des utilisateurs au cours",
  "selected-users": "Utilisateurs sélectionnés",
  "start-date": "Date de début",
  "end-date": "Date de fin",
  "evalus-reports-info": "Vous trouverez ici les « Modèles généraux ». Vous pouvez trouver, créer et gérer des rapports spéciaux dans la rubrique « Listes de contrôle ».",
  role: "Rôle",
  eup: "EUP",
  "efk-tooltip": "Électricien qualifié",
  "eup-tooltip": "Personne avertie en électrotechnique",
  "efk-pending": "Nomination en attente",
  "strictly-required": "Obligatoire",
  "strictly-required-info": "Si activé, le rapport ne peut pas être envoyé si cette validation échoue",
  "validation-failed": "Validation obligatoire échouée",
  "cannot-submit-invalid-required": "Envoi impossible : la validation requise a échoué",
  "create-new-entry": "Créer une nouvelle entrée",
  "trainer-invalid-certificate": "Le formateur n'a plus de certificat HV-4 ou HV-L valable.",
  to: "à",
  "date-filter": "Filtre de date",
  "clear-filter": "Supprimer le filtre",
  "oldest-first": "Les plus anciens d'abord",
  "newest-first": "Les plus récents d'abord",
  "course-documents": "Annexes du cours",
  "select-documents": "Sélectionner des documents",
  "upload-documents": "Télécharger des documents",
  uploading: "Télécharger",
  "drag-and-drop-files": "Glissez et déposez les fichiers ici",
  "drop-files-here": "Déposez les fichiers ici",
  "or-click-to-browse": "ou cliquez pour sélectionner des fichiers",
  "supported-formats": "Formats pris en charge",
  "existing-documents": "Documents existants",
  "documents-uploaded-successfully": "Documents téléchargés avec succès",
  "document-deleted-successfully": "Document supprimé avec succès",
  "no-course-documents-available": "Vous n'êtes actuellement affecté à aucun cours ou aucun document n'a été mis à disposition.",
  "more-files": "Autres fichiers",
  publicProfile: {
    status: {
      valid: "Valable",
      expiringSoon: "Expire bientôt",
      expired: "Expiré",
      certified: "Certifié",
      open: "Ouvert",
      none: "Aucune",
    },
    jobTitle: {
      efk: "HV-ESP",
      hv0: "Personne sensibilisée HT",
      "hv1-3": "HV-EUP",
    },
    experienceStartDate: "Expérience professionnelle depuis",
    backgroundImage: "Image d'arrière-plan",
    totalCertificatesTitle: "Certificats",
    totalCertificatesDescription: "Nombre total de certificats",
    trainingLevelTitle: "Niveau de formation",
    trainingLevelDescription: "Niveau de formation le plus élevé",
    practicalOperationsTitle: "Interventions pratiques",
    practicalOperationsDescription: "Activités pratiques sur des systèmes HT",
    vehicleModelsTitle: "Modèles de véhicules",
    vehicleModelsDescription: "Modèles de véhicules HT pris en charge",
    dashboardTitle: "Tableau de bord de l'expérience HT",
    dashboardSubtitle: "Statistiques complètes et expertise HT",
    certificationsTitle: "Certifications",
    certificationsSubtitle: "Aperçu de la formation initiale et continue dans le domaine HT",
    instructor: "Formateur",
    issuedOn: "Délivré",
    validUntil: "Valable jusqu'au",
    view: "Voir",
    loadMoreCertificates: "Charger d'autres certificats",
    hideCertificates: "Masquer les certificats",
    nav: {
      certifications: "Certifications",
      specialTraining: "Formations spéciales",
      practicalExperiences: "Expériences pratiques",
      vehicleCategories: "Catégories de véhicules",
    },
    specialTraining: {
      title1: "Spécial",
      title2: "Formations",
      subtitle: "Qualifications supplémentaires et formations spéciales",
    },
    practicalExperiences: {
      title1: "Pratiques",
      title2: "Expériences",
      subtitle: "Expérience pratique sur des systèmes HT",
      freischaltungen: {
        title: "Consignations",
        description: "Consignations effectuées sur des systèmes HT",
      },
      isolationstests: {
        title: "Mesures d'isolement",
        description: "Mesures de résistance d'isolement effectuées",
      },
      potentialtests: {
        title: "Liaison équipotentielle",
        description: "Mesures de liaison équipotentielle effectuées",
      },
      checklists: {
        title: "Listes de contrôle effectuées",
        description: "Listes de contrôle de sécurité terminées",
      },
      chargingCableChecks: {
        title: "Contrôles de câbles de charge",
        description: "Inspections de sécurité des câbles certifiées HV-C",
      },
      issuedCertificates: {
        title: "Certificats délivrés",
        description: "Certifications délivrées en tant que formateur",
      },
    },
    vehicleCategories: {
      title1: "Catégorie de véhicule ",
      title2: "Expériences",
      subtitle: "Spécialisé dans les catégories de véhicules et applications suivantes",
    },
    gtpCategories: {
      roadVehicles: "Véhicules routiers",
      machines: "Engins de chantier",
      racingVehicles: "Véhicules de course",
      aircraft: "Aéronefs",
      watercraft: "Bateaux",
      railVehicles: "Véhicules ferroviaires",
      developmentProduction: "R&D",
      aftersales: "Après-vente",
    },
    footer: {
      qrTitle: "Accès par code QR",
      qrSubtitle: "Scannez le code pour un accès rapide au profil",
      qrHint: "Scanner avec la caméra",
      copyright: "© {year} Evalcard.com - Tous droits réservés",
      imprint: "Mentions légales",
      privacy: "Protection des données",
    },
    shareProfile: "Partager le profil",
    currentEmployer: "Employeur actuel",
    linkCopied: "Lien copié avec succès dans le presse-papiers",
    evalusProfile: "Profil Evalus",
    sharingNotSuccessful: "Le partage a échoué.",
    showInvalidCertificates: "Afficher les certificats expirés",
    hideInvalidCertificates: "Masquer les certificats expirés",
    invalidCertificatesHint: "Certificats masqués qui ont été remplacés par de plus récents",
    evalId: "N° Eval-ID",
    ogCertifications: "Certifications",
    ogDescription: "Profil public sur EvalCard",
  },
  academy: {
    academy: "Académie",
    administration: "Administration",
    "my-orders": "Mes commandes",
    "manage-courses": "Gérer les cours",
    data: "Données de base",
    price: "Prix",
    "book-for-me": "Réserver pour moi",
    "book-for-employee": "Réserver pour des collaborateurs",
    passing_score: "Score requis en %",
    max_exam_attempts: "Nombre maximal de tentatives d'examen",
    max_exam_attempts_hint: "0 = illimité",
    exam_attempts_remaining: "Tentatives restantes : {remaining} sur {max}",
    exam_attempts_used: "Tentatives : {used}",
    exam_attempts_limit_reached: "Nombre maximal de tentatives d'examen atteint",
    "edit-course": "@:edit-course",
    "all-languages-have-content": "Des contenus de cours existent déjà pour toutes les langues.",
    "must-be-company-member-to-book": "Vous devez être membre d'une entreprise pour pouvoir réserver des cours.",
  },
  course: {
    course: "Cours",
    courses: "Cours",
    "my-courses": "Mes cours",
    "my-courses-view": "Aperçu du cours",
    content: "Contenu du cours",
    "edit-content": "Modifier le contenu du cours",
    learn: "Apprentissage",
    "learn-trail": "Parcours d'apprentissage",
    exam: "Examen",
    "exam-trail": "Parcours d'examen",
    section: "Domaine",
    addLearnSection: "Ajouter un domaine d'apprentissage",
    addLearnTask: "Ajouter une tâche d'apprentissage",
    addExamSection: "Ajouter un domaine d'examen",
    addExamTask: "Ajouter une question d'examen",
    sectionTitle: "Titre du domaine",
    taskTitle: "Titre de la tâche",
    questionTitle: "Titre de la question",
    enterSectionTitle: "Saisir le titre du domaine...",
    enterTaskTitle: "Saisir le titre de la tâche...",
    enterQuestionTitle: "Saisir le titre de la question...",
    titleRequired: "Le titre est obligatoire",
    titleTooShort: "Le titre doit comporter au moins 2 caractères",
    itemAddedSuccessfully: "Élément ajouté avec succès",
    errorAddingItem: "Erreur lors de l'ajout de l'élément",
    selectItemFromSidebar: "Sélectionnez un élément dans la barre latérale",
    task: "Tâche",
    question: "Question",
    enterTitle: "Saisir le titre...",
    addItem: "Ajouter un élément",
    "purchase-course": "Acheter le cours",
    "purchase-initiated": "Achat lancé avec succès",
    "learning-objectives": "Objectifs d'apprentissage",
    prerequisites: "Prérequis",
    syllabus: "Programme du cours",
    "learn-section": "Section d'apprentissage",
    "exam-section": "Section d'examen",
    free: "Gratuit",
    booking: "Réservation",
    "purchase-date": "Réservé le",
    question_type: {
      question_type: "Type de question",
      multiple_choice: "Choix multiple",
      number: "Numéro",
      yes_no: "Oui / Non",
    },
    operator: {
      operator: "Opérateur",
      equals: "Égal",
      notEquals: "Différent",
      greaterThan: "Supérieur à",
      lessThan: "Inférieur à",
      greaterThanOrEqual: "Supérieur ou égal",
      lessThanOrEqual: "Inférieur ou égal",
    },
    correct_answer: "Réponse correcte",
    yes: "Oui",
    no: "Non",
    answer: "Réponse",
    unit: "Unité",
    select_course: "Sélectionner un cours",
    select_language: "Sélectionner la langue du cours",
    select_users: "Sélectionner un utilisateur",
    error: {
      publish: "Erreur lors de la publication du cours",
      course_content_required: "Au moins un contenu de cours est requis",
      certification_authority_required: "Au moins un organisme de certification est requis",
      certificate_template_missing: "Pour chaque contenu de cours, un modèle de certificat doit être sélectionné pour tous les organismes de certification",
      learn_section_task_required: "Chaque domaine d'apprentissage doit contenir au moins une tâche d'apprentissage",
      exam_section_task_required: "Chaque domaine d'examen doit contenir au moins une question d'examen",
      monetization_required: "Le cours doit être marqué comme gratuit ou avoir un produit Paddle attribué",
    },
    finish_course: "Terminer le cours",
    completed_message: "Vous avez terminé ce cours avec succès.",
    linked_exam_section: "Section d'examen liée",
    linked_exam_section_hint: "Après avoir terminé cette section d'apprentissage, cette section d'examen sera présentée",
    inline_exam_section: "Questions d'examen",
    inline_exam_section_info: "Veuillez répondre à toutes les questions pour continuer. Vos réponses sont définitives.",
    question_progress: "Question {current} sur {total}",
    complete_exam_section: "Terminer la section",
    answered_during_learning: "Répondu pendant l'apprentissage",
    section_already_answered: "Cette section a déjà été répondue",
    answers_are_final: "Les réponses ne peuvent plus être modifiées",
  },
  enrollment: {
    status: {
      in_progress: "Commencé",
      not_started: "Non commencé",
      completed: "Terminé",
    },
    enrolled_courses: "Cours inscrits",
    enroll_course: "Inscrire au cours",
    enrolled_on: "Inscrit le",
  },
  order: {
    order: "Commande | Commandes",
    my_orders: "Mes commandes",
    view_order: "Voir",
    ordered_at: "Commandé le",
    status: {
      paid: "Payé",
      pending: "En attente",
      failed: "Échoué",
      refunded: "Remboursé",
      cancelled: "Annulé",
    },
    payment: {
      paddle: "Paddle",
      request: "Demande",
      none: "Aucune",
    },
    payment_method: "Mode de paiement",
    purchased_by: "Acheté par",
    purchased_for: "Acheté pour",
    product: "Produit",
    "page-title": "Commande",
    thank_you: "Merci pour votre achat !",
    no_transaction_headline: "Commande introuvable",
    no_transaction_text: "Cette commande n'existe pas ou une erreur s'est produite.",
    back_to_courses: "Retour aux cours",
    go_to_my_courses: "Vers mes cours",
    purchase_now: "Acheter maintenant",
    payment_pending: "Paiement en attente",
    payment_pending_text: "Votre commande a été reçue, mais le paiement n'est pas encore terminé. Veuillez finaliser le paiement pour accéder à votre cours.",
    cancel_success: "Commande annulée avec succès",
    cancel_error: "Erreur lors de l'annulation de la commande",
  },
  language: "Langue",
  short_description: "Brève description",
  progress: "Progression",
  total: "Total",
  complete_section: "Terminer la section",
  mark_task_complete: "Marquer la tâche comme effectuée",
  video_not_supported: "Votre navigateur ne prend pas en charge l'élément vidéo.",
  overall_progress: "Progression globale",
  section_progress: "Progression de la section",
  task_completed: "Tâche terminée avec succès",
  section_completed: "Section terminée avec succès",
  error_completing_task: "Erreur lors de l'achèvement de la tâche",
  error_completing_section: "Erreur lors de l'achèvement de la section",
  next: "Continuer",
  finish_learning: "Terminer l'apprentissage",
  start_learning: "Commencer l'apprentissage",
  continue_learning: "Poursuivre l'apprentissage",
  take_exam_attempt: "Commencer l'examen",
  copy_course: "Copier le cours",
  select: "Sélectionner",
  exam_results: {
    congratulations: "Félicitations !",
    not_passed: "Échoué",
    score: "Score",
    you_passed: "Vous avez réussi l'examen !",
    need_score_to_pass: "Vous avez besoin de {score} pour réussir. Veuillez réessayer.",
    score_details: "Détails du score",
    question: "Question",
    back_to_course: "Retour au cours",
    retake_exam: "Repasser l'examen",
    view_certificate: "Afficher le certificat",
    download_certificate: "Télécharger le certificat",
  },
  exam_export: {
    export_pdf: "Exporter en PDF",
    title: "Résultat de l'examen",
    participant: "Participant",
    birthday: "Date de naissance",
    course: "Cours",
    attempt_number: "Tentative",
    started_at: "Commencé le",
    finished_at: "Terminé le",
    overall_score: "Résultat global",
    passed: "Réussi",
    failed: "Échoué",
    given_answer: "Réponse donnée",
    correct_answer: "Réponse correcte",
    no_answer: "Aucune réponse",
    yes: "Oui",
    no: "Non",
    select_attempt: "Sélectionner une tentative",
    no_attempts: "Aucune tentative terminée disponible",
    no_exam: "Ce cours n'a pas d'examen",
    generating: "Le PDF est en cours de création …",
    export_failed: "Export échoué",
  },
  "academy-assignment": {
    title: "Cours de l'académie attribués",
    "academy-course": "Cours de l'académie",
    "available-for-regular-courses": "Sélectionnable pour les cours réguliers",
    "for-regular-courses-badge": "Pour les cours réguliers",
    "cannot-publish-regular-course": "Ce cours ne peut pas être publié car il est destiné aux cours réguliers",
    language: "Langue",
    "select-course-first": "Sélectionner d'abord un cours de l'académie",
    "no-matching-courses": "Aucun cours de l'académie approprié disponible (non publié, validé, niveau approprié)",
    type: "Type",
    "type-entry": "Test d'entrée",
    "type-intermediate": "Test intermédiaire",
    "type-final": "Examen final",
    assign: "Attribuer un cours de l'académie",
    remove: "Retirer l'attribution",
    "remove-warning": "Si l'attribution est retirée, les inscriptions et les résultats d'examen des participants pour ce cours de l'académie seront supprimés. Continuer ?",
    "assigned-successfully": "Cours de l'académie attribué avec succès",
    "removed-successfully": "Attribution retirée avec succès",
    results: "Résultats des participants",
    participant: "Participant",
    score: "Résultat",
    status: "Statut",
    attempts: "Tentative",
    passed: "Réussi",
    failed: "Échoué",
    "in-progress": "En cours",
    "not-started": "Non commencé",
  },
  exam_interface: {
    sections: "Sections",
    overall_progress: "Progression globale",
    questions: "Questions",
    progress: "Progression",
    section: "Section",
    question_of: "Question {current} sur {total}",
    answered: "Répondu",
    not_answered: "Non répondu",
    previous: "Retour",
    next: "Continuer",
    submit_exam: "Terminer l'examen",
    quick_navigation: "Navigation rapide",
    submit_exam_confirm: "Remettre l'examen ?",
    submit_exam_message: "Êtes-vous sûr de vouloir remettre votre examen ?",
    answered_count: "Vous avez répondu à <strong>{answered}</strong> des <strong>{total}</strong> questions.",
    cannot_change_warning: "Après la remise, vous ne pouvez plus modifier vos réponses.",
    loading: "Chargement",
    error: "Erreur",
    back: "Retour",
    select_certificate_authority: "Sélectionner un organisme de certification",
    select_authority_message: "Veuillez sélectionner un organisme de certification pour délivrer votre certificat.",
    no_authorities_available: "Aucun organisme de certification n'est disponible pour ce cours.",
    certificate_issued: "Certificat délivré avec succès !",
    error_issuing_certificate: "Erreur lors de la délivrance du certificat",
    exam_submitted_successfully: "Examen remis avec succès !",
    exam_submit_error: "Erreur lors de la remise de l'examen",
  },
  could_not_add_section: "La section n'a pas pu être ajoutée",
  successfully_added_section: "Section ajoutée avec succès",
  could_not_add_task: "La tâche n'a pas pu être ajoutée",
  successfully_added_task: "Tâche ajoutée avec succès",
  could_not_remove_attachment: "La pièce jointe n'a pas pu être retirée",
  successfully_removed_attachment: "Pièce jointe retirée avec succès",
  could_not_remove_task: "La tâche n'a pas pu être retirée",
  successfully_removed_task: "Tâche retirée avec succès",
  could_not_remove_section: "La section n'a pas pu être retirée",
  successfully_removed_section: "Section retirée avec succès",
  "default-academy-issuer": "Émetteur par défaut des certificats de l'académie",
  "default-academy-issuer-hint": "Délivre automatiquement les certificats des cours de l'académie terminés, sauf si le participant possède déjà un certificat d'un autre organisme associé au cours. Un seul organisme peut être défini par défaut.",
  "academy-documents": "Documents de l'académie",
  "back-to-documents": "Retour à mes documents",
  "completed-on": "Terminé le",
  "my-documents-academy": "Mes documents de l'académie",
  "from-task": "De la tâche",
  "from-section": "De la section",
  "no-documents-in-course": "Aucun document disponible dans ce cours",
  "unknown-course": "Cours inconnu",
  "error-loading-documents": "Erreur lors du chargement des documents",
}
